export default __webpack_public_path__ + "static/testresults-56d3f5d45bcaa930ce9e808ea0481e0f.png";